import React from 'react';
import IconAbstract from '../../Lib/Components/IconAbstract';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBirthdayCake} from '@fortawesome/free-solid-svg-icons';

class DateOfBirthIcon extends IconAbstract {
	renderIcons()
	{
		return (
			<FontAwesomeIcon icon={faBirthdayCake}/>
		)
	}
}

export default DateOfBirthIcon;
